import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_project_wise_claim_count = async (page, limit, payload) => {
    const url = `/v3/guarantee-claims/project/${page}/${limit}?payload=${payload}`; // No need for full base URL, it's handled
    const response = await customAxios.get(url, getAuthHeader());
    return response.data;
};


export const v3_ship_wise_claim_count = async (projectId) => {
    const url = `/v3/guarantee-claims/ship/${projectId}`;
    const response = await customAxios.get(url, getAuthHeader());
    return response.data;
};



export const v3_add_claim = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/guarantee-claims`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_assign_claim = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/guarantee-claim/assign`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const v3_ship_wise_claim_list = async (shipId, payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/guarantee-claims/claims/${shipId}${payload ? `?payload=${payload}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_add_claim_comment = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/guarantee-claims/comment`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_save_claim_file = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/guarantee-claims/files`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}